import type { Prompt, PromptInput, PromptUpdate } from "@akhshy/types";
import { api } from "../lib/api.ts";
import { useResource } from "../lib/useResource.ts";
import { CrudPage } from "../components/organisms/CrudPage.tsx";
import { PromptForm } from "../components/organisms/forms/PromptForm.tsx";
import { Badge } from "../components/atoms/Badge.tsx";
import type { Column } from "../components/organisms/DataTable.tsx";

const columns: Column<Prompt>[] = [
  { header: "Title", render: (i) => <span className="cell-title">{i.title}</span> },
  { header: "Use case", render: (i) => <Badge tone="kind">{i.useCase}</Badge> },
];

export function PromptsPage() {
  const resource = useResource<Prompt, PromptInput, PromptUpdate>(api.prompts);
  return (
    <CrudPage
      intro="Copy-paste prompts organized by use case."
      resource={resource}
      columns={columns}
      emptyText="no prompts yet — add your first."
      newLabel="New prompt"
      formTitle={(editing) => (editing ? "Edit prompt" : "New prompt")}
      itemLabel={(i) => i.title}
      renderForm={(p) => <PromptForm {...p} resource={resource} />}
    />
  );
}
